import { render, staticRenderFns } from "./PlannerTagConfig.vue?vue&type=template&id=15fa1214&"
import script from "./PlannerTagConfig.vue?vue&type=script&lang=js&"
export * from "./PlannerTagConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports